export type LocalStorageKeyInput = string | string[] | null | undefined;

const PARTS = {
  DELIMITER: ':',
  PREFIX: 'keypoint-connect-ui',
};

const CONSTRUCTED_PREFIX = PARTS.PREFIX + PARTS.DELIMITER;

function isCreatedKey(input: NonNullable<LocalStorageKeyInput>): input is string {
  return typeof input === 'string' && input.startsWith(CONSTRUCTED_PREFIX);
}

function join(...args: string[]) {
  return args.join(PARTS.DELIMITER);
}

function parseInput(input: NonNullable<LocalStorageKeyInput>) {
  return typeof input === 'string' ? [input] : input;
}

function createKey(input: NonNullable<LocalStorageKeyInput>): string;

function createKey(input: LocalStorageKeyInput): string | null;

function createKey(input: LocalStorageKeyInput) {
  if (input == null) return null;
  if (isCreatedKey(input)) return input;

  const inputParts = parseInput(input);

  return join(PARTS.PREFIX, ...inputParts);
}

const lsKey = {
  create: createKey,
  join,
  parseInput,
};

export default lsKey;
